export const commarize = ($number) => {
  if (!$number) return 0
  const number = $number?.toString().split('.')
  const mainpart = number[0]
  const minipart = (number.length > 1 ? number[1].toString() : '00').substr(
    0,
    2,
  )
  const numberstring = mainpart?.toString()?.split('')?.reverse() || []
  let formatedstring = ''
  numberstring.forEach((x, i) => {
    if (i % 3 === 0 && i !== 0) formatedstring += ','
    formatedstring += x
  })
  formatedstring = formatedstring.split('').reverse().join('')
  return formatedstring + `.${minipart}`
}

export const getMinutesLeft = (date) => {
  if (!date) return "00:00"
  // Create two Date objects for the start and end times
  const startTime = new Date(); // Replace with your start time
  const endTime = new Date(date);   // Replace with your end time

  // Calculate the time difference in milliseconds
  const timeDifference = endTime - startTime;

  // Convert the time difference to minutes and seconds
  const minutes = Math.floor(timeDifference / 60000); // 1 minute = 60,000 milliseconds
  const seconds = Math.floor((timeDifference % 60000) / 1000); // 1 second = 1,000 milliseconds

  // Format the minutes and seconds as "mm:ss"
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return formattedTime;
}


export const setExpiryTime = (minutesToAdd = 10) => {
  // Create a Date object with the initial time
  const initialTime = new Date(); // Replace with your desired time

  // Add the minutes to the initial time
  return initialTime.setMinutes(initialTime.getMinutes() + minutesToAdd);
}

export function randnumber(length) {
  return Math.random().toString(16).substring(2, 2 + length)
}
